/**
 * API Client
 * 
 * 백엔드 API와 통신하기 위한 Axios 인스턴스 설정
 * Vite 프록시를 사용하여 /api 요청을 백엔드로 전달
 */

import axios from 'axios';

// Vite 프록시를 사용하므로 baseURL은 빈 문자열
// /api/* 요청은 vite.config.ts의 프록시 설정에 의해 http://localhost:3002로 전달됨
const API_BASE_URL = '';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 응답 인터셉터
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    
    // 401 에러시 로그인 페이지로 리다이렉트
    if (error.response?.status === 401) {
      localStorage.removeItem('agentbuilder_token');
      localStorage.removeItem('agentbuilder_user');
      // 현재 로그인 페이지가 아니면 리다이렉트
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
